/*
 * @Author: crazycattle
 * @Date: 2021-05-31 17:42:12
 * @Description: fix url
 */
let language: any = window.localStorage.getItem("languageType");
let winHost = window.location.host;

const urlType = () => {
  if (JSON.parse(language) == "zh") {
    if (winHost.indexOf("chevady.cn") > -1) {
      return "https://stuapi.chevady.cn";
    } else {
      return "https://stuapi.kidcastle.cn";
    }
  } else {
    return "https://stuapi.kidcastleapp.tw";
  }
};
export default urlType();
